import axios from "axios";
import { BASEURL, requestWrapper, setConfig } from "./request.util";

export const getForms = async () => await requestWrapper(axios.get(`${BASEURL}/forms`, setConfig()));

export const getForm = async (id) => await requestWrapper(axios.get(`${BASEURL}/form/${id}`, setConfig()));

export const generateForm = async (formConfig) => await requestWrapper(axios.post(`${BASEURL}/form/generate`, formConfig, setConfig()));

export const addForm = async (formDetails) => await requestWrapper(axios.post(`${BASEURL}/form/create`, formDetails, setConfig()));

export const updateForm = async (id, formDetails) => await requestWrapper(axios.put(`${BASEURL}/form/${id}/edit`, formDetails, setConfig()));

export const getAllFormResponses = async () => await requestWrapper(axios.get(`${BASEURL}/forms/responses`, setConfig()));

export const getAllResponseWithLocation = async () => await requestWrapper(axios.get(`${BASEURL}/responses/withLocation`, setConfig()));

export const getResponseById = async (id) => await requestWrapper(axios.get(`${BASEURL}/response/${id}`, setConfig()));

export const getResponseAnalysisById = async (id) => await requestWrapper(axios.get(`${BASEURL}/response/${id}/analysis`, setConfig()));

export const analyseResponseById = async (id, chat) => await requestWrapper(axios.post(`${BASEURL}/response/${id}/analyse`, chat, setConfig()));

export const deleteForm = async (id) => await requestWrapper(axios.delete(`${BASEURL}/form/${id}/delete`, setConfig()));

export const downloadFormResponseFormat = async (id) => await requestWrapper(axios.get(`${BASEURL}/form/${id}/download-input-csv`, {
    ...setConfig(),
    responseType: 'blob'
}));

export const uploadFormResponses = async (id, responses) => await requestWrapper(axios.post(`${BASEURL}/form/${id}/upload-responses`, responses, setConfig()));

export const exportFormResponses = async (id) => await requestWrapper(axios.get(`${BASEURL}/form/${id}/export-responses`, {
    ...setConfig(),
    responseType: 'blob'
}));

export const exportSelectedFormResponses = async (id, responses) => await requestWrapper(axios.post(`${BASEURL}/form/${id}/export-selected-responses`, responses, setConfig()));


export const updateResponse = async (id, responses) => await requestWrapper(axios.put(`${BASEURL}/response/${id}/update-response`, responses, setConfig()));

export const deleteResponse = async (id) => await requestWrapper(axios.delete(`${BASEURL}/response/${id}/delete-response`, setConfig()));

export const deleteResponseAnalysis = async (id) => await requestWrapper(axios.delete(`${BASEURL}/response/${id}/analysis`, setConfig()));